import { Stack } from "@mui/material";
import { PHIcons } from "../Icons/PHIcons";
import "./Notification.styles.css";
import { API_TSE } from "../../api/ssoapi/SSOapi";
import { API_Notification, API_Notify } from "../../api/notifyapi/Notifyapi";
import { useEffect } from "react";

type NotificationModalBodyProps = {
  header: string;
  description: string;
  notificationId: string;
  actions: {
    close: () => void;
  };
  files: IFileData[];
};

export const NotificationModalBody = ({
  header,
  actions,
  description,
  files,
  notificationId,
}: NotificationModalBodyProps) => {
  const downloadFile = () => {};
  return (
    <>
      <Stack direction={"column"} rowGap={2}>
        <Stack className="notification-modal-container" direction={"column"}>
          <label style={{wordBreak:'break-word'}}>{header}</label>
          <div style={{ marginTop: "15px", wordBreak:'break-word' }}> {description}</div>
        </Stack>
        {files?.length > 0 && (
          <>
            {files?.map((file) => (
              <DownloadfileComponent data={file} download={downloadFile} notificationId={notificationId} />
            ))}
          </>
        )}
        <Stack direction={"row"} justifyContent={"flex-end"}>
          <button className="close-button" onClick={actions.close}>
            Close
          </button>
        </Stack>
      </Stack>
    </>
  );
};

export interface IFileData {
  fileName: string;
  fileSize: string;
  filePath: any;
}

type DownloadfilecomponentProps = {
  data: any;
   notificationId: string;
  download: () => void;
};

export const DownloadfileComponent = ({
  data,
  download,
  notificationId ,
}: DownloadfilecomponentProps) => {
 
  const handleDownload = async (): Promise<void> => {
    try {
        await API_Notification.DownloadFile(notificationId, data.fileName);
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        className="download-container"
        alignItems={"center"}
      >
        <Stack direction="row" columnGap={1} alignItems={"center"}>
          <span className="description-icon">
            {PHIcons.DescriptionOutlinedIcon}
          </span>
          <Stack direction="column">
            <label className="file-name">{data.fileName}</label>
            <label className="file-size">{data.fileSize}</label>
          </Stack>
        </Stack>

        <span
          className="arrow-downward-icon"
          onClick={handleDownload}
        >
          {PHIcons.ArrowDownwardIcon}
        </span>
      </Stack>
    </>
  );
};
